import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import { RedirectedApiClientsList } from "../../administration/api-clients-request/RedirectedApiClientsList";

export default {
  icon: LanguageOutlinedIcon,
  list: RedirectedApiClientsList,
};
